<template>
  <!-- Modal terms -->
  <div
    class="modal fade show"
    id="establish-date-description"
    tabindex="-1"
    role="dialog"
    aria-labelledby="establishAtModal"
    aria-hidden="false"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="establishAtModal">{{ $t('Mükellef olma tarihi neden önemli') }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <!-- <p>Mükellef olduğunuz günden itibaren; içinde bulunduğunuz aya ait vergi yükümlülükleriniz hemen başlar. Örneğin 31 Ocak olarak girerseniz Ocak ayına ait vergi borcunuz oluşur. Dolayısıyla buraya gireceğiniz tarihin, işe başlayacağınız tarih olmasına özen gösterin.</p> -->
          <iframe
            width="560"
            height="315"
            class="full-width"
            src="https://www.youtube.com/embed/RNzCjc1Yd6w"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
    <a id="establishAtModal" href="#" data-toggle="modal" data-target="#establish-date-description"></a>
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'EstablishAtDescriptionModal',
};
</script>
